angular.module("vgresiduos").controller("MtrFollowUpCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";
		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "acompanhamento-mtrs", getQueries());
		};

		function getQueries() {
			return [{ key: "mtrCode", value: $stateParams.mtr }];
		}
	}
]);
